import {useEffect} from 'react';
import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import backendService from '../../../services/app/backendService';
import cmClientService from '../../../services/communicationLayer/cmClientService';
import yapConnectionService from '../../../services/yap/yapConnectionService';
import yapWebSocketService from '../../../services/yap/yapWebSocketService';
import {makeSelectIsNetworkOnline} from '../../../state/selectors/global';
import {
    makeSelectIsDeviceSyncInProgress,
    makeSelectIsOfflineYapFirmwareInProgress,
    makeSelectIsYapAutoCleaningInProgress,
    makeSelectIsYapFirmwareInProgress,
    makeSelectIsYapSynchronizeDataCollectionInProgress,
    makeSelectIsYapUpdateSettingsInProgress,
} from '../../../state/selectors/yapEncrypted';

const mapStateToProps = createStructuredSelector({
    isDeviceSyncInProgress: makeSelectIsDeviceSyncInProgress(),
    isHolderSyncInProgress: makeSelectIsDeviceSyncInProgress(true),
    isAutoCleaningInProgress: makeSelectIsYapAutoCleaningInProgress(),
    isYapUpdateSettingsInProgress: makeSelectIsYapUpdateSettingsInProgress(),
    isYapHolderUpdateSettingsInProgress: makeSelectIsYapUpdateSettingsInProgress(true),
    isYapFirmwareInProgress: makeSelectIsYapFirmwareInProgress(),
    isOfflineYapFirmwareInProgress: makeSelectIsOfflineYapFirmwareInProgress(),
    isYapSynchronizeDataCollectionInProgress: makeSelectIsYapSynchronizeDataCollectionInProgress(),
    isNetworkOnline: makeSelectIsNetworkOnline(),
});

const YapOfflineDetector = ({
    isDeviceSyncInProgress,
    isHolderSyncInProgress,
    isAutoCleaningInProgress,
    isYapUpdateSettingsInProgress,
    isYapHolderUpdateSettingsInProgress,
    isYapFirmwareInProgress,
    isOfflineYapFirmwareInProgress,
    isYapSynchronizeDataCollectionInProgress,
    isNetworkOnline,
}) => {
    const isGamBackend = backendService.isGamBackend();
    const isFlowInProgress =
        isDeviceSyncInProgress ||
        isHolderSyncInProgress ||
        isAutoCleaningInProgress ||
        isYapUpdateSettingsInProgress ||
        isYapHolderUpdateSettingsInProgress ||
        isYapFirmwareInProgress ||
        isOfflineYapFirmwareInProgress ||
        isYapSynchronizeDataCollectionInProgress;

    useEffect(() => {
        if (isNetworkOnline || isFlowInProgress) return;

        cmClientService.disconnectCmClient(false, false);
        cmClientService.disconnectCmClient(true, false);
    }, [isNetworkOnline, isFlowInProgress]);

    const forceReconnectToCm = async () => {
        if (isOfflineYapFirmwareInProgress) return;

        await yapConnectionService.forceReconnectToCm(false, false);

        await yapConnectionService.forceReconnectToCm(true, false);
    };

    useEffect(() => {
        if (isNetworkOnline) {
            forceReconnectToCm();
        } else if (isGamBackend) {
            yapWebSocketService.disconnectYapWebSocket(undefined, false);
        }
    }, [isNetworkOnline]);

    return null;
};

export default connect(mapStateToProps)(YapOfflineDetector);
